module.exports = __webpack_public_path__ + "img/DlawarQaradaghy.4f88e47a.jpg";